/**
 * Mitigation and vehicle domain contracts.
 * Mirrors server/app/domain/mitigation/contracts.py
 * Mirrors server/app/domain/vehicles/contracts.py
 */

export enum VehicleClass {
  PASSENGER = 'passenger',
  MOTORCYCLE = 'motorcycle',
  LIGHT_TRUCK = 'light_truck',
  HEAVY_TRUCK = 'heavy_truck',
  BUS = 'bus',
  EMERGENCY = 'emergency',
}

export enum TreatmentMaterial {
  ROCK_SALT = 'rock_salt',
  CALCIUM_CHLORIDE = 'calcium_chloride',
  MAGNESIUM_CHLORIDE = 'magnesium_chloride',
  BRINE = 'brine',
  SAND = 'sand',
  BEET_JUICE_BLEND = 'beet_juice_blend',
}

export interface Citation {
  source: string;
  reference: string;
  url: string | null;
  accessed: string;
}

export interface MitigationPlan {
  material: TreatmentMaterial;
  apply_by: string;
  quantity: number;
  units: string;
  expected_effect: string;
  citations: Citation[];
}

export interface VehicleVulnerability {
  vehicle_class: VehicleClass;
  min_safe_friction: number;
  stopping_distance_multiplier: number;
}

export const VEHICLE_CLASS_LABELS: Record<VehicleClass, string> = {
  [VehicleClass.PASSENGER]: 'Passenger Vehicles',
  [VehicleClass.MOTORCYCLE]: 'Motorcycles',
  [VehicleClass.LIGHT_TRUCK]: 'Light Trucks',
  [VehicleClass.HEAVY_TRUCK]: 'Heavy Trucks',
  [VehicleClass.BUS]: 'Buses',
  [VehicleClass.EMERGENCY]: 'Emergency Vehicles',
};

export const TREATMENT_MATERIAL_LABELS: Record<TreatmentMaterial, string> = {
  [TreatmentMaterial.ROCK_SALT]: 'Rock Salt (NaCl)',
  [TreatmentMaterial.CALCIUM_CHLORIDE]: 'Calcium Chloride',
  [TreatmentMaterial.MAGNESIUM_CHLORIDE]: 'Magnesium Chloride',
  [TreatmentMaterial.BRINE]: 'Salt Brine',
  [TreatmentMaterial.SAND]: 'Sand/Abrasive',
  [TreatmentMaterial.BEET_JUICE_BLEND]: 'Beet Juice Blend',
};
